<div class="filter-control">
    <fsx-select
      label="Judge"
      [control]="formControl"
      [options]="judgeOptions">
    </fsx-select>
  </div>